export default "__VITE_ASSET__CJS9xU3h__"